import { render, staticRenderFns } from "./CharacterList.vue?vue&type=template&id=728ffd06&"
import script from "./CharacterList.vue?vue&type=script&lang=ts&"
export * from "./CharacterList.vue?vue&type=script&lang=ts&"
import style0 from "./CharacterList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports